/*
 *
 * Audiences reducer
 *
 */
import produce from 'immer';

import { notification } from 'antd';

import {
  FLUSH_STATE_AUDIENSES,
  // load items list
  LOAD_AUDIENSES,
  LOAD_AUDIENSES_SUCCESS,
  LOAD_AUDIENSES_ERROR,
} from './constants';

export const initialState = {
  firstRender: true,
  loading: true,
  error: false,
  itemsList: [],
  allData: false,
  totalPages: 1,
  limit: 1,
  page: 1,
  totalAmount: 0,
  
  // filter list
  params: {
    sortBy: 1,
    page: 1
  },
  noMore: false,
};

import { getUniqueArrayObj } from 'utils/helpers/helper.general';

/* eslint-disable default-case, no-param-reassign */
const communicationsReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE_AUDIENSES:
        return initialState;

      // LOAD
      case LOAD_AUDIENSES:
        draft.firstRender = action.firstRender;
        draft.params = action.params;
        draft.loading = true;
        draft.error = false;
        break;
      
      case LOAD_AUDIENSES_SUCCESS:
        draft.loading = false;
        draft.allData = action.allData;
        draft.totalAmount = action.allData?.totalDocs || 0;
        draft.totalPages = action.allData?.totalPages || 1;
        draft.limit = action.allData?.limit || 1;
        draft.page = action.allData?.page || 1;
        draft.itemsList = action.itemsList;

        // set No More action
        if (action.allData?.page == action.allData?.totalPages) {
          draft.noMore = true;
        }
        break;

      case LOAD_AUDIENSES_ERROR:
        draft.error = action.error;
        draft.loading = false;
        draft.firstRender = false;
        break;

    }
  });

export default communicationsReducer;
